import { Directions, Languages } from "./global.constants";

export * from "./global.constants";
export * from "./forgotPasswordConst";
export * from "./login.constants";
export * from "./registration.contants";
export * from "./api.constants";
export * from "./competition.constants";
export * from "./serverResponse/serverResponse.constants";
export * from "./googleMap.constants";
export * from "./translation.constants";
export * from "./spot.constants";
export * from "./subscription.constant";
export * from "./freelanceInstructor.constant";
export * from "./subscriptionType.constants";
export * from "./admin.constants";
export * from "./instructor.constants";
export * from "./profile.constants";
export * from "./documentType.constants";
export * from "./sport.constants";
export * from "./documentStatus.constants";
export * from "./mode.constants";
export * from "./country.constants";
export * from "./centers.constants";
export * from "./center.constants";
export * from "./centerListing.constant";
export * from "./system.constants";
export * from "./centerActivity.constants";
export * from "./level.constants";
export * from "./student.constants";
export * from "./questionTypes.constants";
export * from "./feedbackTypes.constants";
export * from "./dashboard.constants";
export * from "./centerActivity.constants";
export * from "./calender.constants";
export * from "./event.constants";
export * from "./refundPolicy.constants";
export * from "./boatType.constants";
export * from "./leaderboard.constants";
export * from "./payment.constants";
export * from "./auditLogs.constants";
export * from "./invoice.constants";

export const globalConstants = {
  REQUEST: "_REQUEST",
  SUCCESS: "_SUCCESS",
  FAILURE: "_FAILURE",
  ROLES_META: "_ROLES_META",
  COMMON_HR_URL: "/api/v1/hr",
  COMMON_CORE_URL: "/api/v1/common",
  COMMON_USER_URL: "/api/v1/user",
  COMMON_AUDIT_URL: "/api/v1/audit",
  COMMON_META_URL: "/api/v1/meta/metaData",
  COMMON_DOMAIN: "suitestgapi.hazelsoft.net",
  BASE_DOMAIN: "suitestg.hazelsoft.net",
  SIGNALR_URL: "/api/v1/hr-hub/signalR",
  CORE_SIGNALR_URL: "/api/v1/auth-hub/signalR",
  VERSION: "v1",
  DEFAULT_LANGUAGE: Languages.AR,
  DEFAULT_DIRECTION: Directions.rtl,
  EMPTY_STRING: "",
  EMPTY_OBJECT: {},
  SORT: {
    ASC: "asc",
    DESC: "desc",
  },
  SCREEN_BREAKPOINTS: {
    xs: 575,
    sm: 767,
    md: 991,
    lg: 1199,
    xl: 1399,
  },
  TRUE: 1,
  FALSE: 0,
  Mandatory_Character: "*",
  DateFormatPlaceholder: "mm/dd/yyyy",
  EMAIL_PLACEHOLDER: "Ex: abc@example.com",
};

export const globalSystemConstants = {
  SPINNER_ACTIVATE: "SPINNER_ACTIVATE",
  SPINNER_DEACTIVATE: "SPINNER_DEACTIVATE",
};

export const emptyString = "";

export const roles = {
  SuperAdmin: 8,
  Admin: 9,
  Instructor: 2,
  Practioner: 3,
  VerifiedUser: 4,
  GeneralUser: 5,
  Center: 6,
  FreelanceInstructor: 7,
};

export const getRoleById = (id) => {
  const roles = {
    8: "Super Admin",
    9: "Admin",
    2: "Instructor",
    3: "Sailor",
    4: "Verified User",
    5: "General User",
    6: "Center",
    7: "Freelance Instructor",
  };
  return roles[id];
};

export const documentsIds = {
  0: "NationalId/Iqama",
  1: "Passport",
  2: "FamilyCard",
  3: "Kitesurfing",
  4: "Windsurfing",
  5: "Wingfoiling",
  6: "Sailing",
};
export function getNameById(id) {
  return documentsIds[id];
}

export const instructorTypes = {
  FREELANCE: "Freelance",
  NONE: "None",
  CENTER: "Center",
};

export const environmentConstants = {
  DEVELOPMENT: "development",
};

export const socialMediaConstants = {
  TWITTER: "twitter",
  INSTAGRAM: "instagram",
  FACEBOOK: "facebook",
  TIKTOK: "tiktok",
};

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

export const contactEmail = process.env.REACT_APP_CONTACT_EMAIL;

export const contentType = { CSV: "application/octet-stream" };

export const fieldLengthConstants = {
  TEXT_FIELD_LENGTH: 50,
  EMAIL_FIELD_LENGTH: 200,
  PHONENUMBER_FIELD_LENGTH: 20,
  LOCATION_FIELD_LENGTH: 500,
  NUMBER_FIELD_VALUE: 2147483647,
  EVENT_COMPETITION_NAME_FIELD_LENGTH: 70,
};

export const Regex = {
  urlRegex:
    /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/,
  titleRegex: /^[A-Za-z0-9\s!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/i,
  emailRegex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/i,
  fifteenDigitsOnlyRegex: /^\d{15}$/,
  refundPercentageRegex: /^(100|[1-9]?\d|0)%$/,
};
